import React from "react";
import LineageTransformationViewer from "./LineageTransformationViewer";
import heartLoading from "../../../../assests/heartLoading.gif";
import useLineageTransformationData from "./useLineageTransformationData";

const LineageTransformationModal = ({ assetName, handleClose }) => {
  const {
    handleSelectMermaid,
    loading,
    mermaidTypes,
    selectedMermaid,
  } = useLineageTransformationData({ assetName });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg shadow-xl w-[90vw] h-[90vh] overflow-hidden">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">
              Lineage Transformation
            </h2>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full"
            title="Close"
          >
            <svg
              className="h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div className="px-2 pb-2 pt-0 h-[calc(90vh-80px)] flex flex-col min-h-0 overflow-hidden">
          <LineageTransformationViewer
            loading={loading}
            selectedMermaid={selectedMermaid}
            mermaidTypes={mermaidTypes}
            onSelectMermaid={handleSelectMermaid}
            assetName={assetName}
            loadingImage={heartLoading}
            loadingMessage="Loading lineage transformation..."
            emptyMessage="No resources found!"
            emptyTextClassName="text-gray-700 text-[20px]"
            rootClassName="h-full flex flex-col min-h-0"
          />
        </div>
      </div>
    </div>
  );
};

export default LineageTransformationModal;
